// Custom Photos Index
// Add your photos to the appropriate directories and import them here

import { getApiImageUrl } from '../../utils/imageUrl'

const imageUrl = (filename: string) => getApiImageUrl(filename)

// Hero Images
export const heroImages = {
  // Add your hero images here
  // Example: communityHero: '/src/assets/images/hero/community-hero.jpg',
  
  // Uncomment and update these lines with your actual photo filenames:
  // communityHero: '/src/assets/images/hero/your-community-photo.jpg',
  // foodDonation: '/src/assets/images/hero/your-food-donation-event.jpg',
  // volunteerGroup: '/src/assets/images/hero/your-volunteer-group.jpg',
};

// Food Bank Images
export const foodBankImages = {
  // Add your food bank images here
  // Example: foodBankOperations: '/images/food-banks/operations.jpg',
  
  // Uncomment and update these lines with your actual photo filenames:
  foodBankOfEnc: imageUrl('food-bank-of-enc.jpg'),
  // storage: '/images/food-banks/your-storage-facility.jpg',
  // volunteers: '/images/food-banks/your-volunteers-working.jpg',
};

// Supplier Images
export const supplierImages = {
  // Add your supplier images here
  // Example: freshProduce: '/images/suppliers/fresh-produce.jpg',
  
  // Uncomment and update these lines with your actual photo filenames:
  wholeFoods: imageUrl('whole-foods.webp'),
  // restaurantDonation: '/images/suppliers/your-restaurant-donation.jpg',
  // groceryStore: '/images/suppliers/your-grocery-store.jpg',
};

// Volunteer Images
export const volunteerImages = {
  // Add your volunteer images here
  // Example: volunteerHelping: '/images/volunteers/helping.jpg',
  me: imageUrl('me.jpeg'),
};

// Community Images
export const communityImages = {
  // Add your community images here
  communityGathering: imageUrl('wordpress-blog-logo.png'),
  communityGathering2: imageUrl('donating-food.jpg'),
  communityGathering3: imageUrl('food_insecurity3.jpg'),
  communityGathering4: imageUrl('food_insecurity4-1.jpeg'),
  communityGathering5: imageUrl('food-insecurity1.jpg'),
  communityGathering6: imageUrl('fruits.jpg'),
  communityGathering7: imageUrl('waste2-1.jpg'),
};

// Success Story Images
export const successStoryImages = {
  // Add your success story images here
  successStory1: imageUrl('me.jpeg'),
};

// All images combined
export const allImages = {
  ...heroImages,
  ...foodBankImages,
  ...supplierImages,
  ...volunteerImages,
  ...communityImages,
  ...successStoryImages,
};
